import React, { createContext, useState } from "react";
import Cookies from "js-cookie";
import { useEffect } from "react";

const MyContext = createContext();

const MyContextProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [contextData, setContextData] = useState(
    JSON.parse(localStorage.getItem("contextData") || "[]") || []
  );
  const [guestCartData, setGuestCartData] = useState(() => {
    const storedData = Cookies.get("guestCartData");
    return storedData ? JSON.parse(storedData) : [];
  });

  console.log("guestCartData: ", guestCartData);
  const [cartList, setCartList] = useState([]);
  const [wishList, setWishList] = useState([]);
  const [userContaxtDetails, setUserContaxtDetails] = useState({});
  const updateToken = (newData) => {
    setToken(newData);
    localStorage.setItem("token", newData);
  };
  const updateData = (newData) => {
    setContextData(newData);
    localStorage.setItem("contextData", JSON.stringify(newData));
  };
  const updateGuestCartData = (newData) => {
    setGuestCartData(newData);
    // Set cookie with 4-hour expiration
    Cookies.set("guestCartData", JSON.stringify(newData), {
      expires: 1 / 6, // 4 hours (1 day = 24 hours; 4/24 = 1/6)
    });
  };

  const callCartDetails = async () => {
    let userInfo = JSON.parse(localStorage?.getItem("userDetails") || "{}");
    let token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");
    if (userInfo) {
      let formData = new FormData();
      if (userInfo?.id) {
        formData.append("customerId", userInfo?.id);
      }
      formData.append("clientId", process.env.REACT_APP_Client_Id);

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}cartbycustomer?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (data && data.status) {
            setCartList(data?.cartList);
          }
        })
        .catch((error) => {
          console.log("error: ", error);
        });
      // const apiCall = await getCartDetails(formData);
      // if (apiCall.status) {
      //   setCartList(apiCall?.cartList);
      // } else {
      //   toast.error(apiCall?.message);
      // }
    }
  };
  const callWishListApi = async () => {
    let userInfo = JSON.parse(localStorage?.getItem("userDetails") || "{}");
    let token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");
    if (userInfo) {
      let formData = new FormData();
      if (userInfo?.id) {
        formData.append("customerId", userInfo?.id);
      }
      formData.append("clientId", process.env.REACT_APP_Client_Id);

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}wishlistbycustomer?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (data && data.status) {
            setWishList(data?.wishList);
          }
        })
        .catch((error) => {
          console.log("error: ", error);
        });
      // const apiCall = await getCartDetails(formData);
      // if (apiCall.status) {
      //   setCartList(apiCall?.cartList);
      // } else {
      //   toast.error(apiCall?.message);
      // }
    }
  };

  const callCustomerDetails = async () => {
    let userInfo = JSON.parse(localStorage?.getItem("userDetails") || "{}");
    let token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    let formData = new FormData();
    formData.append("customerId", userInfo?.id);

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}customerdetailsbycustomerid?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status) {
          setUserContaxtDetails({
            customerName: data?.customerList?.[0]?.customerName,
            customerEmail: data?.customerList?.[0]?.customerEmail,
            customerMobile: data?.customerList?.[0]?.customerMobile,
            customerAlterMobile: data?.customerList?.[0]?.customerAlterMobile,
            customerWalletBalance: data?.customerList?.[0]?.walletBalance,
            customerReferralCode: data?.customerList?.[0]?.referralCode,
          });
        }
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  useEffect(() => {
    // Cleanup expired cookie on mount if necessary (not strictly needed with cookies)
    const storedData = Cookies.get("guestCartData");
    if (!storedData) {
      setGuestCartData([]);
    }
  }, []);
  return (
    <MyContext.Provider
      value={{
        token,
        updateToken,
        contextData,
        updateData,
        callCartDetails,
        cartList,
        wishList,
        callWishListApi,
        guestCartData,
        updateGuestCartData,
        userContaxtDetails,
        callCustomerDetails,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export { MyContext, MyContextProvider };
